export default __webpack_public_path__ + "static/media/premium-clock-icon-ionic.a2439d6a38665f41e2a75b211352fe54.svg";